<app-progress-spinner *ngIf="!showGrid"></app-progress-spinner>
<div class="container">
    <div class="col-md-12 col-lg-12 label-header">
        <label class="label-headercolor label-text">Product LifeCycle Costs - Direct Costs</label>
    </div>
    <div style="overflow-x: scroll; overflow-y: hidden; white-space: nowrap;">
        <div class="col-md-4 col-lg-4 label-header" style="display: inline-block;">
            <!-- <label class="label-headercolor">Reference Scenario: {{ referenceTitle }} </label> -->
            <label class="label-headercolor">Reference Scenario: {{refTitle}}
            </label>
        </div>

        <div class="col-md-6 col-lg-6 label-header" style="margin-left: 15px; display: inline-block;">
            <!-- <label class="label-headercolor">Reference Scenario: {{ referenceTitle }} </label> -->
            <label class="label-headercolor">Target Scenario: {{tarTitle}}
            </label>
        </div>

        <div *ngIf="optAVisible" class="col-md-6 col-lg-6 label-header" style="margin-left: 15px; display: inline-block;">
                <label class="label-headercolor">Option A: {{optATitle}}
                </label>
        </div>

        <div *ngIf="optBVisible" class="col-md-6 col-lg-6 label-header" style="margin-left: 15px; display: inline-block;"> 
                <label class="label-headercolor">Option B: {{optBTitle}}
                </label>
        </div>

        <div *ngIf="optCVisible" class="col-md-6 col-lg-6 label-header" style="margin-left: 15px; display: inline-block;">
                <label class="label-headercolor">Option C: {{optCTitle}}
                </label>
        </div>

        <br>
        <div class="col-md-4 col-lg-4" style="padding-left: 0px;padding-right: 0px; display: inline-block;">
            <ag-grid-angular *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine" id="refGrid"
                [rowData]="gridData" [columnDefs]="refColumnDefs" [rowClassRules]="rowClassRulesRef"
                [domLayout]="domLayout" [frameworkComponents]="refFrameworkComponents"
                [defaultColDef]="refDefaultColDef" [headerHeight]="headerHeight" [enableBrowserTooltips]="true"
                [popupParent]="popupParent" (cellValueChanged)="onRefCellValueChanged($event)"
                (gridReady)="onRefGridReady($event)" (gridSizeChanged)="onGridRefChanged($event)"
                [getRowHeight]="getRowHeightRef" (columnResized)="onColumnResizedRef($event)"
                (columnVisible)="onColumnVisibleRef($event)" [rowHeight]="rowHeight" [headerHeight]="headerHeight">
            </ag-grid-angular>
        </div>

        <div class="col-md-6 col-lg-6"
            style="margin-left: 15px;padding-left: 0px;padding-right: 0px; display: inline-block;">
            <ag-grid-angular *ngIf="showGrid" style="width: 100%;" class="ag-theme-alpine" id="refGrid"
                [rowData]="tarGridData" [columnDefs]="tarColumnDefs" [rowClassRules]="rowClassRulesTar"
                [context]="{referenceApi: refGridApi}"
                [domLayout]="refdomLayout" [frameworkComponents]="tarFrameworkComponents"
                [defaultColDef]="tarDefaultColDef" [headerHeight]="headerHeight" [enableBrowserTooltips]="true"
                [popupParent]="popupParent" 
                (gridReady)="onTarGridReady($event)" (gridSizeChanged)="onGridTarChanged($event)"
                [getRowHeight]="getRowHeightTar" (columnResized)="onColumnResizedTar($event)"
                (columnVisible)="onColumnVisibleTar($event)" [rowHeight]="rowHeight" [headerHeight]="headerHeight">
            </ag-grid-angular>
        </div>

        <div *ngIf="optAVisible" class="col-md-6 col-lg-6"
            style="margin-left: 15px;padding-left: 0px;padding-right: 0px; display: inline-block;">
            <ag-grid-angular *ngIf="optAVisible" style="width: 100%;" class="ag-theme-alpine" id="optAGrid" [rowData]="optAGridData"
                [columnDefs]="optAColumnDefs" [rowClassRules]="rowClassRulesOptA" [domLayout]="OptADomLayout"
                [context]="{referenceApi: refGridApi}"
                [frameworkComponents]="optAFrameworkComponents" [defaultColDef]="optADefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onOptACellValueChangedCS($event)" (gridReady)="onOptAGridReady($event)"
                (gridSizeChanged)="onGridOptACSChanged($event)" (columnResized)="onColumnResizedOptA($event)"
                (columnVisible)="onColumnVisibleOptA($event)" [rowHeight]="rowHeight" [headerHeight]="headerHeight">
            </ag-grid-angular>
        </div>

        <div *ngIf="optBVisible" class="col-md-6 col-lg-6"
            style="margin-left: 15px;padding-left: 0px;padding-right: 0px; display: inline-block;">
            <ag-grid-angular *ngIf="optBVisible" style="width: 100%;" class="ag-theme-alpine" id="optBGrid" [rowData]="optBGridData"
                [columnDefs]="optBColumnDefs" [rowClassRules]="rowClassRulesOptB" [domLayout]="OptBDomLayout"
                [context]="{referenceApi: refGridApi}"
                [frameworkComponents]="optBrameworkComponents" [defaultColDef]="optBDefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onOptBCellValueChangedCS($event)" (gridReady)="onOptBGridReady($event)"
                (gridSizeChanged)="onGridOptBCSChanged($event)" (columnResized)="onColumnResizedOptB($event)"
                (columnVisible)="onColumnVisibleOptB($event)" [rowHeight]="rowHeight" [headerHeight]="headerHeight">
            </ag-grid-angular>
        </div>

        <div *ngIf="optCVisible" class="col-md-6 col-lg-6"
            style="margin-left: 15px;padding-left: 0px;padding-right: 0px; display: inline-block;">
            <ag-grid-angular *ngIf="optCVisible" style="width: 100%;" class="ag-theme-alpine" id="optCGrid" [rowData]="optCGridData"
                [columnDefs]="optCColumnDefs" [rowClassRules]="rowClassRulesOptC" [domLayout]="OptCDomLayout"
                [context]="{referenceApi: refGridApi}"
                [frameworkComponents]="optCFrameworkComponents" [defaultColDef]="optCDefaultColDef"
                [enableBrowserTooltips]="true" [popupParent]="popupParent"
                (cellValueChanged)="onOptCCellValueChangedCS($event)" (gridReady)="onOptCGridReady($event)"
                (gridSizeChanged)="onGridOptCCSChanged($event)" (columnResized)="onColumnResizedOptC($event)"
                (columnVisible)="onColumnVisibleOptC($event)" [rowHeight]="rowHeight" [headerHeight]="headerHeight">
            </ag-grid-angular>
        </div>
        <br>
    </div>

    <div class="row" style="margin-top:0px">
        <div class="offset-4 col-md-8">
            <div class="buttonStyle" style="float: right; margin-right: 5px; margin-bottom: -20px">
                <button class="button button--small" (click)="onClickCancel()">
                    Cancel & Exit</button>&nbsp;
                <button class="button button--small" [disabled]="submitted" (click)="onClickBack()">
                    Back</button>&nbsp;
                <button class="button button--small" [disabled]="submitted" (click)="onClickNext()">
                    Next</button>&nbsp;
                <button class="button button--small" [disabled]="submitted" (click)="submit($event)" type="submit">
                    Save & Exit
                </button>
            </div>
        </div>
    </div>


    <br>
    <app-commentbox *ngIf="objData?.configurationId" #commentBox [configData]="objData" (unsavedChangesChange)="onCommentUnsavedChange($event)"></app-commentbox>
</div>